export const MODAL_ROOT_SCROLLED_CLASS = 'isScrolled'

/**
 * Apply bright visible background colors to modal components for debugging purposes.
 */
export const MODAL_DEBUG = false
